module.exports = __webpack_public_path__ + "img/04.f77ad3c8.png";